import React, { FC } from 'react';

type SurgeFactorsSideModalInputType = {
  factor: string;
  value: string | number;
  onChange: (val: string) => void;
};
const SurgeFactorsInput: FC<SurgeFactorsSideModalInputType> = ({ factor, value, onChange }) => {
  return (
    <div className='flex mb-7 font-light text-sm w-full'>
      <span className='border-y border-l rounded-l-lg w-2/5 bg-[#F5F5F6] py-4 border-[#E0DADB] pr-5 pl-6'>
        {factor}
      </span>

      <input
        className='w-80 border-y border-r rounded-r-lg px-3 py-4 text-[#A6A6A6] border-[#E0DADB]'
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
};

export default SurgeFactorsInput;
